export const KEY_MAP_DOCS = [
  {
    sequences: ['c'],
    description: 'Copy shareable link to clipboard',
  },
  {
    sequences: ['m'],
    description: 'Toggle masked mode',
  },
  {
    sequences: ['o', 'cmd+k', 'ctrl+k'],
    description: 'Omnibar',
  },
  {
    sequences: ['cmd+shift+f'],
    description: 'Hide Navigation',
  },
  {
    sequences: ['esc'],
    description: 'Restore header and sidebar',
  },
];
